// extracted by mini-css-extract-plugin
export default {"wrapper":"DataSourceGNBConfigurationTable_wrapper__EdVCv"};